const tables = {
    upload: 'Upload',
    customerType: 'CustomerType',
    permission: 'Permission',
    supplier: 'Supplier',
    typeOfVaccine: 'TypeOfVaccine',
    paymentMethod: 'PaymentMethod',
    shipment: 'Shipment',
    vaccine: 'Vaccine',
    staff: 'Staff',
    customer: 'Customer',
    additionalCustomerInformation: 'AdditionalCustomerInformation',
    vaccinePrice: 'VaccinePrice',
    regulationCustomer: 'RegulationCustomer',
    regulationInjection: 'RegulationInjection',
    promotion: 'Promotion',
    screeningExamination: 'ScreeningExamination',
    vaccinePackage: 'VaccinePackage',
    vaccinePackageDetail: 'VaccinePackageDetail',
    customerRank: 'CustomerRank',
    customerRankDetail: 'CustomerRankDetail',
    conditionPromotion: 'ConditionPromotion',
    login: 'Login',
    order: 'Order',
    orderDetail: 'OrderDetail',
    entrySlip: 'EntrySlip',
    entrySlipDetail: 'EntrySlipDetail',
    loginSession: 'LoginSession',
    pay: 'Pay',
    payDetail: 'PayDetail',
    injectionSchedule: 'InjectionSchedule',
    injectionScheduleDetail: 'InjectionScheduleDetail',
    injectionIncident: 'InjectionIncident',
    statistical: 'Statistical',
    auth: 'Auth',
    permissionDetail: 'PermissionDetails',
};
const urlApi = {
    //Upload
    uploadImage: `${tables.upload}/UploadImage`,
    //CustomerType
    getCustomerTypes: `${tables.customerType}/GetCustomerTypes`,
    getCustomerType: `${tables.customerType}/GetCustomerType`,
    getAllCustomerTypes: `${tables.customerType}/GetAllCustomerTypes`,
    searchCustomerTypes: `${tables.customerType}/SearchCustomerTypes`,
    deleteCustomerType: `${tables.customerType}/DeleteCustomerType`,
    insertCustomerType: `${tables.customerType}/InsertCustomerType`,
    insertCustomerTypesRange: `${tables.customerType}/InsertCustomerTypesRange`,
    updateCustomerType: `${tables.customerType}/UpdateCustomerType`,
    //Permission
    getPermissions: `${tables.permission}/GetPermissions`,
    getAllPermissions: `${tables.permission}/GetAllPermissions`,
    searchPermissions: `${tables.permission}/SearchPermissions`,
    deletePermission: `${tables.permission}/DeletePermission`,
    insertPermission: `${tables.permission}/InsertPermission`,
    insertPermissionsRange: `${tables.permission}/InsertPermissionsRange`,
    updatePermission: `${tables.permission}/UpdatePermission`,
    //Supplier
    getSuppliers: `${tables.supplier}/GetSuppliers`,
    searchSuppliers: `${tables.supplier}/SearchSuppliers`,
    deleteSupplier: `${tables.supplier}/DeleteSupplier`,
    insertSupplier: `${tables.supplier}/InsertSupplier`,
    insertSuppliersRange: `${tables.supplier}/InsertSuppliersRange`,
    updateSupplier: `${tables.supplier}/UpdateSupplier`,
    getSupplier: `${tables.supplier}/GetSupplier`,
    getAllSuppliers: `${tables.supplier}/GetAllSuppliers`,
    //TypeOfVaccine
    getTypeOfVaccines: `${tables.typeOfVaccine}/GetTypeOfVaccines`,
    getAllTypeOfVaccines: `${tables.typeOfVaccine}/GetAllTypeOfVaccines`,
    getTypeOfVaccine: `${tables.typeOfVaccine}/GetTypeOfVaccine`,
    searchTypeOfVaccines: `${tables.typeOfVaccine}/SearchTypeOfVaccines`,
    deleteTypeOfVaccine: `${tables.typeOfVaccine}/DeleteTypeOfVaccine`,
    insertTypeOfVaccine: `${tables.typeOfVaccine}/InsertTypeOfVaccine`,
    insertTypeOfVaccinesRange: `${tables.typeOfVaccine}/InsertTypeOfVaccinesRange`,
    updateTypeOfVaccine: `${tables.typeOfVaccine}/UpdateTypeOfVaccine`,
    //Vaccine
    getVaccines: `${tables.vaccine}/GetVaccines`,
    getVaccine: `${tables.vaccine}/GetVaccine`,
    getVaccineByShipmentId: `${tables.vaccine}/GetVaccineByShipmentId`,
    getAllVaccines: `${tables.vaccine}/GetAllVaccines`,
    searchVaccines: `${tables.vaccine}/SearchVaccines`,
    deleteVaccine: `${tables.vaccine}/DeleteVaccine`,
    insertVaccine: `${tables.vaccine}/InsertVaccine`,
    insertVaccinesRange: `${tables.vaccine}/InsertVaccinesRange`,
    updateVaccine: `${tables.vaccine}/UpdateVaccine`,
    //VaccinePrice
    getVaccinePrices: `${tables.vaccinePrice}/GetVaccinePrices`,
    getVaccinePriceLastByVaccineIdAndShipmentId: `${tables.vaccinePrice}/GetVaccinePriceLastByVaccineIdAndShipmentId`,
    searchVaccinePrices: `${tables.vaccinePrice}/SearchVaccinePrices`,
    deleteVaccinePrice: `${tables.vaccinePrice}/DeleteVaccinePrice`,
    insertVaccinePrice: `${tables.vaccinePrice}/InsertVaccinePrice`,
    insertVaccinePricesRange: `${tables.vaccinePrice}/InsertVaccinePricesRange`,
    updateVaccinePrice: `${tables.vaccinePrice}/UpdateVaccinePrice`,
    //VaccinePackage
    getVaccinePackages: `${tables.vaccinePackage}/GetVaccinePackages`,
    getVaccinePackage: `${tables.vaccinePackage}/GetVaccinePackage`,
    getAllVaccinePackages: `${tables.vaccinePackage}/GetAllVaccinePackages`,
    searchVaccinePackages: `${tables.vaccinePackage}/SearchVaccinePackages`,
    deleteVaccinePackage: `${tables.vaccinePackage}/DeleteVaccinePackage`,
    insertVaccinePackage: `${tables.vaccinePackage}/InsertVaccinePackage`,
    insertVaccinePackagesRange: `${tables.vaccinePackage}/InsertVaccinePackagesRange`,
    updateVaccinePackage: `${tables.vaccinePackage}/UpdateVaccinePackage`,
    //VaccinePackageDetail
    getVaccinePackageDetailsByVaccinePackageId: `${tables.vaccinePackageDetail}/GetVaccinePackageDetailsByVaccinePackageId`,
    getVaccinePackageDetail: `${tables.vaccinePackageDetail}/GetVaccinePackageDetail`,
    getAllVaccinePackageDetails: `${tables.vaccinePackageDetail}/GetAllVaccinePackageDetails`,
    searchVaccinePackageDetails: `${tables.vaccinePackageDetail}/SearchVaccinePackageDetails`,
    deleteVaccinePackageDetail: `${tables.vaccinePackageDetail}/DeleteVaccinePackageDetail`,
    deleteVaccinePackageDetailByVaccinePackageId: `${tables.vaccinePackageDetail}/DeleteVaccinePackageDetailByVaccinePackageId`,
    insertVaccinePackageDetail: `${tables.vaccinePackageDetail}/InsertVaccinePackageDetail`,
    insertVaccinePackageDetailsRange: `${tables.vaccinePackageDetail}/InsertVaccinePackageDetailsRange`,
    updateVaccinePackageDetail: `${tables.vaccinePackageDetail}/UpdateVaccinePackageDetail`,
    updateVaccinePackageDetailsRange: `${tables.vaccinePackageDetail}/UpdateVaccinePackageDetailsRange`,
    //RegulationCustomer
    getRegulationCustomers: `${tables.regulationCustomer}/GetRegulationCustomers`,
    getAllRegulationCustomers: `${tables.regulationCustomer}/GetAllRegulationCustomers`,
    getRegulationCustomerByCustomerTypeIdAndVaccineId: `${tables.regulationCustomer}/GetRegulationCustomerByCustomerTypeIdAndVaccineId`,
    searchRegulationCustomers: `${tables.regulationCustomer}/SearchRegulationCustomers`,
    deleteRegulationCustomer: `${tables.regulationCustomer}/DeleteRegulationCustomer`,
    insertRegulationCustomer: `${tables.regulationCustomer}/InsertRegulationCustomer`,
    insertRegulationCustomersRange: `${tables.regulationCustomer}/InsertRegulationCustomersRange`,
    updateRegulationCustomer: `${tables.regulationCustomer}/UpdateRegulationCustomer`,
    //RegulationInjection
    getRegulationInjections: `${tables.regulationInjection}/GetRegulationInjections`,
    getAllRegulationInjections: `${tables.regulationInjection}/GetAllRegulationInjections`,
    getRegulationInjectionByVaccineId: `${tables.regulationInjection}/GetRegulationInjectionByVaccineId`,
    searchRegulationInjections: `${tables.regulationInjection}/SearchRegulationInjections`,
    deleteRegulationInjection: `${tables.regulationInjection}/DeleteRegulationInjection`,
    insertRegulationInjection: `${tables.regulationInjection}/InsertRegulationInjection`,
    insertRegulationInjectionsRange: `${tables.regulationInjection}/InsertRegulationInjectionsRange`,
    updateRegulationInjection: `${tables.regulationInjection}/UpdateRegulationInjection`,
    //ScreeningExamination
    getScreeningExaminations: `${tables.screeningExamination}/GetScreeningExaminations`,
    searchScreeningExaminations: `${tables.screeningExamination}/SearchScreeningExaminations`,
    deleteScreeningExamination: `${tables.screeningExamination}/DeleteScreeningExamination`,
    insertScreeningExamination: `${tables.screeningExamination}/InsertScreeningExamination`,
    updateScreeningExamination: `${tables.screeningExamination}/UpdateScreeningExamination`,
    //PaymentMethod
    getPaymentMethods: `${tables.paymentMethod}/GetPaymentMethods`,
    getAllPaymentMethods: `${tables.paymentMethod}/GetAllPaymentMethods`,
    searchPaymentMethods: `${tables.paymentMethod}/SearchPaymentMethods`,
    deletePaymentMethod: `${tables.paymentMethod}/DeletePaymentMethod`,
    insertPaymentMethod: `${tables.paymentMethod}/InsertPaymentMethod`,
    insertPaymentMethodsRange: `${tables.paymentMethod}/InsertPaymentMethodsRange`,
    updatePaymentMethod: `${tables.paymentMethod}/UpdatePaymentMethod`,
    //Shipment
    getShipments: `${tables.shipment}/GetShipments`,
    getShipmentsByIds: `${tables.shipment}/GetShipmentsByIds`,
    getShipmentsBySupplierId: `${tables.shipment}/GetShipmentsBySupplierId`,
    getShipmentsByVaccineId: `${tables.shipment}/GetShipmentsByVaccineId`,
    getAllShipments: `${tables.shipment}/GetAllShipments`,
    getShipment: `${tables.shipment}/GetShipment`,
    searchShipments: `${tables.shipment}/SearchShipments`,
    deleteShipment: `${tables.shipment}/DeleteShipment`,
    insertShipment: `${tables.shipment}/InsertShipment`,
    insertShipmentsRange: `${tables.shipment}/InsertShipmentsRange`,
    updateShipment: `${tables.shipment}/UpdateShipment`,
    //Staff
    getStaffs: `${tables.staff}/GetStaffs`,
    getStaff: `${tables.staff}/GetStaff`,
    getAllStaffs: `${tables.staff}/GetAllStaffs`,
    searchStaffs: `${tables.staff}/SearchStaffs`,
    deleteStaff: `${tables.staff}/DeleteStaff`,
    insertStaff: `${tables.staff}/InsertStaff`,
    insertStaffsRange: `${tables.staff}/InsertStaffsRange`,
    updateStaff: `${tables.staff}/UpdateStaff`,
    //Promotion
    getPromotions: `${tables.promotion}/GetPromotions`,
    getPromotion: `${tables.promotion}/GetPromotion`,
    getAllPromotions: `${tables.promotion}/GetAllPromotions`,
    searchPromotions: `${tables.promotion}/SearchPromotions`,
    deletePromotion: `${tables.promotion}/DeletePromotion`,
    insertPromotion: `${tables.promotion}/InsertPromotion`,
    updatePromotion: `${tables.promotion}/UpdatePromotion`,
    updateCountPromotionsRange: `${tables.promotion}/UpdateCountPromotionsRange`,
    //Customer
    getCustomers: `${tables.customer}/GetCustomers`,
    getCustomer: `${tables.customer}/GetCustomer`,
    getCustomersEligible: `${tables.customer}/GetCustomersEligible`,
    getAllCustomers: `${tables.customer}/GetAllCustomers`,
    GetCustomerByIds: `${tables.customer}/GetCustomerByIds`,
    searchCustomers: `${tables.customer}/SearchCustomers`,
    deleteCustomer: `${tables.customer}/DeleteCustomer`,
    insertCustomer: `${tables.customer}/InsertCustomer`,
    insertCustomersRange: `${tables.customer}/InsertCustomersRange`,
    updateCustomer: `${tables.customer}/UpdateCustomer`,

    //CustomerRank
    getCustomerRanks: `${tables.customerRank}/GetCustomerRanks`,
    getCustomerRank: `${tables.customerRank}/GetCustomerRank`,
    getCustomerRankByCustomerId: `${tables.customerRank}/GetCustomerRankByCustomerId`,
    getAllCustomerRanks: `${tables.customerRank}/GetAllCustomerRanks`,
    searchCustomerRanks: `${tables.customerRank}/SearchCustomerRanks`,
    deleteCustomerRank: `${tables.customerRank}/DeleteCustomerRank`,
    insertCustomerRank: `${tables.customerRank}/InsertCustomerRank`,
    insertCustomerRanksRange: `${tables.customerRank}/InsertCustomerRanksRange`,
    updateCustomerRank: `${tables.customerRank}/UpdateCustomerRank`,

    //AdditionalCustomerInformation
    getAdditionalCustomerInformations: `${tables.additionalCustomerInformation}/GetAdditionalCustomerInformations`,
    getAllAdditionalCustomerInformations: `${tables.additionalCustomerInformation}/GetAllAdditionalCustomerInformations`,
    getAdditionalCustomerInformationByIds: `${tables.additionalCustomerInformation}/GetAdditionalCustomerInformationByIds`,
    searchAdditionalCustomerInformations: `${tables.additionalCustomerInformation}/SearchAdditionalCustomerInformations`,
    deleteAdditionalCustomerInformation: `${tables.additionalCustomerInformation}/DeleteAdditionalCustomerInformation`,
    insertAdditionalCustomerInformation: `${tables.additionalCustomerInformation}/InsertAdditionalCustomerInformation`,
    insertAdditionalCustomerInformationsRange: `${tables.additionalCustomerInformation}/InsertAdditionalCustomerInformationsRange`,
    updateAdditionalCustomerInformation: `${tables.additionalCustomerInformation}/UpdateAdditionalCustomerInformation`,
    updateAdditionalCustomerInformationsRange: `${tables.additionalCustomerInformation}/UpdateAdditionalCustomerInformationsRange`,

    //ConditionPromotion
    getConditionPromotions: `${tables.conditionPromotion}/GetConditionPromotions`,
    getConditionPromotionByVaccineId: `${tables.conditionPromotion}/GetConditionPromotionByVaccineId`,
    getConditionPromotionByPaymentMethodId: `${tables.conditionPromotion}/GetConditionPromotionByPaymentMethodId`,
    getConditionPromotionByVaccinePackageId: `${tables.conditionPromotion}/GetConditionPromotionByVaccinePackageId`,
    getConditionPromotionByCustomerRankId: `${tables.conditionPromotion}/GetConditionPromotionByCustomerRankId`,
    searchConditionPromotions: `${tables.conditionPromotion}/SearchConditionPromotions`,
    deleteConditionPromotion: `${tables.conditionPromotion}/DeleteConditionPromotion`,
    insertConditionPromotion: `${tables.conditionPromotion}/InsertConditionPromotion`,
    updateConditionPromotion: `${tables.conditionPromotion}/UpdateConditionPromotion`,

    //Login
    getLogins: `${tables.login}/GetLogins`,
    getAllLogins: `${tables.login}/GetAllLogins`,
    resetPassword: `${tables.login}/ResetPassword`,
    changePassword: `${tables.login}/ChangePassword`,
    searchLogins: `${tables.login}/SearchLogins`,
    deleteLogin: `${tables.login}/DeleteLogin`,
    insertLogin: `${tables.login}/InsertLogin`,
    updateLoginValidate: `${tables.login}/UpdateLoginValidate`,
    updateLoginLock: `${tables.login}/UpdateLoginLock`,

    //Order
    getOrders: `${tables.order}/GetOrders`,
    getOrder: `${tables.order}/GetOrder`,
    getAllOrders: `${tables.order}/GetAllOrders`,
    searchOrders: `${tables.order}/SearchOrders`,
    deleteOrder: `${tables.order}/DeleteOrder`,
    insertOrder: `${tables.order}/InsertOrder`,
    updateOrderStatus: `${tables.order}/UpdateOrderStatus`,

    //OrderDetail
    getOrderDetailsByOrderId: `${tables.orderDetail}/GetOrderDetailsByOrderId`,
    getOrderDetailsByOrderIdVaccineIdShipmentId: `${tables.orderDetail}/GetOrderDetailsByOrderIdVaccineIdShipmentId`,
    deleteOrderDetail: `${tables.orderDetail}/DeleteOrderDetail`,
    deleteOrderDetailsByOrderId: `${tables.orderDetail}/DeleteOrderDetailsByOrderId`,
    insertOrderDetail: `${tables.orderDetail}/InsertOrderDetail`,
    insertOrderDetailsRange: `${tables.orderDetail}/InsertOrderDetailsRange`,
    updateOrderDetail: `${tables.orderDetail}/UpdateOrderDetail`,

    //EntrySlip
    getEntrySlips: `${tables.entrySlip}/GetEntrySlips`,
    getEntrySlipsByOrderId: `${tables.entrySlip}/GetEntrySlipsByOrderId`,
    searchEntrySlips: `${tables.entrySlip}/SearchEntrySlips`,
    deleteEntrySlip: `${tables.entrySlip}/DeleteEntrySlip`,
    insertEntrySlip: `${tables.entrySlip}/InsertEntrySlip`,

    //EntrySlipDetail
    getEntrySlipDetailsByEntrySlipId: `${tables.entrySlipDetail}/GetEntrySlipDetailsByEntrySlipId`,
    getEntrySlipDetailsByEntrySlipIds: `${tables.entrySlipDetail}/GetEntrySlipDetailsByEntrySlipIds`,
    deleteEntrySlipDetail: `${tables.entrySlipDetail}/DeleteEntrySlipDetail`,
    deleteEntrySlipDetailsByEntrySlipId: `${tables.entrySlipDetail}/DeleteEntrySlipDetailsByEntrySlipId`,
    insertEntrySlipDetail: `${tables.entrySlipDetail}/InsertEntrySlipDetail`,
    insertEntrySlipDetailsRange: `${tables.entrySlipDetail}/InsertEntrySlipDetailsRange`,
    updateEntrySlipDetail: `${tables.entrySlipDetail}/UpdateEntrySlipDetail`,

    //LoginSession
    getLoginSessions: `${tables.loginSession}/GetLoginSessions`,
    searchLoginSessions: `${tables.loginSession}/SearchLoginSessions`,
    deleteLoginSession: `${tables.loginSession}/DeleteLoginSession`,
    insertLoginSession: `${tables.loginSession}/InsertLoginSession`,
    updateLoginSession: `${tables.loginSession}/UpdateLoginSession`,

    //Pay
    getPays: `${tables.pay}/GetPays`,
    getPay: `${tables.pay}/GetPay`,
    getPayByInjectionScheduleId: `${tables.pay}/GetPayByInjectionScheduleId`,
    searchPays: `${tables.pay}/SearchPays`,
    insertPay: `${tables.pay}/InsertPay`,

    //PayDetail
    getPayDetails: `${tables.payDetail}/GetPayDetails`,
    insertPayDetailsRange: `${tables.payDetail}/InsertPayDetailsRange`,
    insertPayDetail: `${tables.payDetail}/InsertPayDetail`,

    //CustomerRankDetail
    getCustomerRankDetails: `${tables.customerRankDetail}/GetCustomerRankDetails`,
    getCustomerRankDetailByPayId: `${tables.customerRankDetail}/GetCustomerRankDetailByPayId`,
    searchCustomerRankDetails: `${tables.customerRankDetail}/SearchCustomerRankDetails`,
    insertCustomerRankDetail: `${tables.customerRankDetail}/InsertCustomerRankDetail`,
    updateCustomerRankDetail: `${tables.customerRankDetail}/UpdateCustomerRankDetail`,

    //InjectionSchedule
    getInjectionSchedules: `${tables.injectionSchedule}/GetInjectionSchedules`,
    getAllInjectionSchedules: `${tables.injectionSchedule}/GetAllInjectionSchedules`,
    getInjectionSchedule: `${tables.injectionSchedule}/GetInjectionSchedule`,
    searchInjectionSchedules: `${tables.injectionSchedule}/SearchInjectionSchedules`,
    deleteInjectionSchedule: `${tables.injectionSchedule}/DeleteInjectionSchedule`,
    insertInjectionSchedule: `${tables.injectionSchedule}/InsertInjectionSchedule`,
    updateInjectionSchedule: `${tables.injectionSchedule}/UpdateInjectionSchedule`,

    //InjectionScheduleDetail
    getInjectionScheduleDetails: `${tables.injectionScheduleDetail}/GetInjectionScheduleDetails`,
    deleteInjectionScheduleDetail: `${tables.injectionScheduleDetail}/DeleteInjectionScheduleDetail`,
    deleteInjectionScheduleDetailsByInjectionScheduleId: `${tables.injectionScheduleDetail}/DeleteInjectionScheduleDetailsByInjectionScheduleId`,
    insertInjectionScheduleDetail: `${tables.injectionScheduleDetail}/InsertInjectionScheduleDetail`,
    insertInjectionScheduleDetailsRange: `${tables.injectionScheduleDetail}/InsertInjectionScheduleDetailsRange`,
    updatePayInjectionScheduleDetails: `${tables.injectionScheduleDetail}/UpdatePayInjectionScheduleDetails`,
    updateInjectionInjectionScheduleDetail: `${tables.injectionScheduleDetail}/UpdateInjectionInjectionScheduleDetail`,
    updateAddressInjectionStaffInjectionScheduleDetail: `${tables.injectionScheduleDetail}/UpdateAddressInjectionStaffInjectionScheduleDetail`,
    //InjectionIncident
    getInjectionIncidents: `${tables.injectionIncident}/GetInjectionIncidents`,
    searchInjectionIncidents: `${tables.injectionIncident}/SearchInjectionIncidents`,
    insertInjectionIncident: `${tables.injectionIncident}/InsertInjectionIncident`,
    //Statistical
    getVaccineOutOfStocks: `${tables.statistical}/GetVaccineOutOfStocks`,
    getShipmentExpires: `${tables.statistical}/GetShipmentExpires`,
    getShipmentInventorys: `${tables.statistical}/GetShipmentInventorys`,
    getTopCustomerPays: `${tables.statistical}/GetTopCustomerPays`,
    getRevenueByDate: `${tables.statistical}/GetRevenueByDate`,
    getRevenueByYear: `${tables.statistical}/GetRevenueByYear`,
    getRevenuesEachMonthOfYear: `${tables.statistical}/GetRevenuesEachMonthOfYear`,
    getRevenuesOther: `${tables.statistical}/GetRevenuesOther`,
    getRevenuesQuarterOfYear: `${tables.statistical}/GetRevenuesQuarterOfYear`,
    getRevenueByMonth: `${tables.statistical}/GetRevenueByMonth`,
    getInjectionIncidentByMonth: `${tables.statistical}/GetInjectionIncidentByMonth`,
    getOrderEntrySlipByDate: `${tables.statistical}/GetOrderEntrySlipByDate`,
    getOrderEntrySlipByYear: `${tables.statistical}/GetOrderEntrySlipByYear`,
    getOrderEntrySlipsEachMonthOfYear: `${tables.statistical}/GetOrderEntrySlipsEachMonthOfYear`,
    getOrderEntrySlipsOther: `${tables.statistical}/GetOrderEntrySlipsOther`,
    getOrderEntrySlipsQuarterOfYear: `${tables.statistical}/GetOrderEntrySlipsQuarterOfYear`,
    getOrderEntrySlipByMonth: `${tables.statistical}/GetOrderEntrySlipByMonth`,
    getEntrySlipsOfMonthByOrder: `${tables.statistical}/GetEntrySlipsOfMonthByOrder`,
    //auth
    logout: `${tables.auth}/Logout`,
    login: `${tables.auth}/Login`,
    refreshToken: `${tables.auth}/RefreshToken`,
    //PermissionDetail
    getControllerNames: `${tables.permissionDetail}/GetControllerNames`,
    getControllerNamesPaging: `${tables.permissionDetail}/GetControllerNamesPaging`,
    getPermissionDetails: `${tables.permissionDetail}/GetPermissionDetails`,
    getPermissionDetailsByNameAndPermissionId: `${tables.permissionDetail}/GetPermissionDetailsByNameAndPermissionId`,
    searchControllerNames: `${tables.permissionDetail}/SearchControllerNames`,
    insertPermissionDetails: `${tables.permissionDetail}/InsertPermissionDetails`,
    deletePermissionDetails: `${tables.permissionDetail}/DeletePermissionDetails`,
};
export default urlApi;
